import React, { useContext } from 'react';
import './styles.css';
import P from 'prop-types';
import ImgCredito from '../../img/pgto_entrega.png';
import ImgDinheiro from '../../img/dinheiro.png';
import { Capitalize } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';
import { Image } from '../Image';

export const FormasPagamento = ({ troco = 0, onSelect, itemSelected }) => {
  const { dadosApp } = useContext(GlobalContext);

  if (itemSelected === undefined) {
    itemSelected = { id: 0 };
  }

  const handleOnSelect = (forma) => {
    if (onSelect != undefined) {
      onSelect(forma);
    }
  };

  return (
    <div>
      <p style={{ margin: '10px 0 15px', fontSize: '14px' }}>
        Nós levamos a máquininha de cartão até você, e você escolhe com qual bandeira deseja pagar.
      </p>
      {dadosApp.FormasPagamento?.map((forma, index) => {
        if (forma.especie === 'ESPECIE') {
          return (
            <span
              key={'el' + index}
              className="small-badge"
              style={{
                border: itemSelected.id === forma.id ? '2px solid #50a773' : '2px solid #ced4da',
                background: itemSelected.id === forma.id ? '#d7ecdf' : '#FFF',
                cursor: 'pointer',
                borderRadius: 10,
                lineHeight: 2,
                width: '100%',
                color: itemSelected.id === forma.id ? '#000000' : '#64707c',
              }}
              onClick={() => handleOnSelect(forma)}
            >
              {/* <img src={ImgDinheiro} alt={forma.descricao} /> */}
              <Image srcLocal={ImgDinheiro} alt={forma.descricao} />
              <small>{Capitalize(forma.descricao)}</small>
              {troco > 0 && <span style={{ fontSize: '12px', color: 'gray' }}> *Troco para R$ {troco}</span>}
              {itemSelected.id === forma.id && (
                <i
                  style={{ float: 'right', color: '#50a773', marginTop: 3, fontWeight: 600 }}
                  className="material-icons"
                >
                  check
                </i>
              )}
            </span>
          );
        } else {
          return (
            <span
              key={'el' + index}
              className="small-badge"
              style={{
                border: itemSelected.id == forma.id ? '2px solid #50a773' : '2px solid #ced4da',
                background: itemSelected.id === forma.id ? '#d7ecdf' : '#FFF',
                cursor: 'pointer',
                borderRadius: 10,
                lineHeight: 2,
                width: '100%',
                color: itemSelected.id === forma.id ? '#000000' : '#64707c',
              }}
              onClick={() => handleOnSelect(forma)}
            >
              {/* <img src={ImgCredito} alt={forma.descricao} /> */}
              <Image srcLocal={ImgCredito} alt={forma.descricao} />
              <small>{Capitalize(forma.descricao)}</small>
              {itemSelected.id === forma.id && (
                <i
                  style={{ float: 'right', color: '#50a773', marginTop: 3, fontWeight: 600 }}
                  className="material-icons"
                >
                  check
                </i>
              )}
            </span>
          );
        }
      })}
    </div>
  );
};

FormasPagamento.propTypes = {
  troco: P.number,
  onSelect: P.func,
  itemSelected: P.object,
};
